import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegisterMappingUpdated } from "routes/asset-register/plugins/asset-mapping/register-mapping-updated"
import { uniqueId } from "library/database/split-id.mjs"
import { getRegisterTypeId } from "routes/asset-register/plugins/asset-mapping/server/get-register-type-id.mjs"
import { globalMappingStatus } from "routes/asset-register/plugins/asset-mapping/global-mapping-status"

export function useIsBeingMapped(type) {
    const { register } = useBoundContext()
    RegisterMappingUpdated(uniqueId(register?._id)).useRefresh()
    if (!register) return false
    const key = getRegisterTypeId(register._id, type)
    return !!globalMappingStatus[uniqueId(register._id)]?.includes(key)
}
